import { memo } from 'react';
import { useTranslation } from '@betty/i18n';
import { Box, Text, Styles, ViewStyle } from '@betty/moonlight';

function LocationDenied(props: Styles<ViewStyle>) {
  const [t] = useTranslation('mkodo');

  return (
    <Box gap="space-600" alignItems="center" justifyContent="center" {...props}>
      <Text
        variant="h5"
        textAlign="center"
        color="darkSurfacePrimary"
        locKey="locationDeniedTitle"
        locNS="mkodo"
      />
      <Text variant="body-m-semi" textAlign="center" color="darkSurfacePrimary">
        {t('locationDeniedDescription', { context: 'web' })}
      </Text>
    </Box>
  );
}

export default memo(LocationDenied);
